import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Prism from "prismjs";
import "../vendor/css/prism-default.css";
import "../scss/posts.scss";

export default function RedirectPage() {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  const nameExt = " | charlie-gp";
  const [postTitle, postDate, readTime] = [
    "Redirect Page in React",
    "Nov. 11, 2022",
    "2min. read",
  ];

  return (
    <div id="posts">
      <Helmet>
        <title>{postTitle + nameExt}</title>
      </Helmet>
      <div id="post-date">
        <small>
          {postDate} &nbsp;&bull;&nbsp; {readTime} &nbsp;&bull;&nbsp;{" "}
          <Link to="/blog/">Blog</Link>
        </small>
      </div>

      <p id="post-title">{postTitle}</p>

      <br />
      <p>
        The code below is intended to redirect the user upon landed 404 page.
        But, this would result an error to due to an Invalid Hook Call in React.
      </p>
      <pre>
        <code className="language-javascript">
          {`
import useNavigate from "react-router-dom";

export default function NotFound() {

  setTimeout(() => { 
    const navigate = useNavigate; 
    navigate('/', { replace: true }) 
  }, 5000);

  return (
    
    <div>
      <p>404 | Not found</p>
      <p>Redirecting...</p>
    </div>
  );
}                        
          `}
        </code>
      </pre>

      <br />
      <p>
        We should avoid breaking the rules of Hooks by NOT doing the following:
      </p>
      <ul>
        <li>Do not call Hooks in class components.</li>
        <li> Do not call in event handlers.</li>
        <li>
          Do not call Hooks inside functions passed to useMemo, useReducer, or
          useEffect.
        </li>
      </ul>
      <p>
        See more on &nbsp;
        <a href="https://reactjs.org/warnings/invalid-hook-call-warning.html">
          React Docs.
        </a>
      </p>

      <br />
      <p>
        In order to fix the problem, remove useNavigate Hook inside of{" "}
        <code>setTimeout()</code> method and do the Vanilla way instead:{" "}
      </p>
      <pre>
        <code className="language-javascript">
          {`
export default function NotFound() {

  setTimeout(() => { window.location.href = "/"; }, 5000);

  return (
    <div>
      <p>404 | Not found</p>
      <p>Redirecting...</p>
    </div>
  );
}             
          `}
        </code>
      </pre>
      <p>and that simply statisfies my needs :)</p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
